import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  public question;
  public showNotifyClientOption = false;
  public notifyClient = true;

  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService) { }

  ngOnInit() {
  }

  close(bool) {
    if (bool) {
      this.modalService.setDismissReason(bool);
    }
    this.bsModalRef.hide();
  }

}
